import Styled from "styled-components";

export const TopicsContainer = Styled.div`
    width: 100%;
    gap: 0.625rem;
`;

export const TopicsFilter = Styled.div`
    display: flex; 
    flex-direction: column;
    margin-top: 0.625rem;
    overflow: auto;
    width: 100%;
    ::-webkit-scrollbar {
        display: none; // Safari and Chrome
    }
    -ms-overflow-style: none;  // IE and Edge
    scrollbar-width: none;  // Firefox
`;
